import type { NextBestActions } from 'src/app/types';
import { NBA_KEYS } from 'src/consts';

import AnyDrAnyMedNBACard from './Cards/AnyDrAnyMed/AnyDrAnyMed';
import JustSayCapsuleNBACard from './Cards/JustSayCapsule/JustSayCapsule';

export const NEXT_BEST_ACTIONS: NextBestActions = {
  [NBA_KEYS.transferRx]: {
    description: 'Move your prescriptions from another pharmacy',
    action: 'Start a transfer',
    segmentName: 'View Transfer Form',
    link: '/rx/transferpharmacy',
    iconSource: '/public/storefront.svg',
    color: 'capsuleBlue50',
  },
  [NBA_KEYS.showYourDoctor]: {
    description: 'Tell your doctor to send prescriptions to Capsule',
    action: 'Get started',
    segmentName: 'Show Your Doctor',
    link: '/rx/show-your-doctor',
    iconSource: '/public/stethoscope_icon.svg',
    color: 'capsuleGreen60',
  },
  [NBA_KEYS.addFamilyMember]: {
    description: 'Manage your family’s prescriptions',
    action: 'Add a family member',
    segmentName: 'View Add Family Member',
    link: '/rx/account/add/dependent',
    iconSource: '/public/add-patient.svg',
    color: 'capsuleGreen60',
  },
  [NBA_KEYS.viewEssentials]: {
    description: 'Looking for allergy, cold and flu, or pain relief?',
    action: 'Shop essentials',
    segmentName: 'View Essentials',
    link: '/rx/shop',
    iconSource: '/public/nba_view_essentials.svg',
    color: 'capsuleGreen60',
  },
  [NBA_KEYS.justSayCapsule]: {
    Component: JustSayCapsuleNBACard,
    segmentName: 'Just Say Capsule',
  },
  [NBA_KEYS.anyDrAnyMed]: {
    Component: AnyDrAnyMedNBACard,
    segmentName: 'Any Dr Any Med',
  },
};
